<template lang="jade" src="../_partials/button.jade"></template>
<script>
  import _ from 'lodash'
  import { Interrupt } from 'src/services/resources'
  import buttons from '../_shared/traits'

  export default {
    data () {
      return {
        stripe: this.$parent.$parent.stripe,
        fields: this.$parent.$parent.fields
      }
    },
    mixins: [buttons],
    computed: {
      disabled () {
        let errors = _.filter(this.notifications, ['type', 'error'])
        return errors.length > 0
      }
    },
    methods: {
      click () {
        this.submit()
      },
      submit () {
        let card = _.head(this.fields).element
        this.stripe.createToken(card, {name: this.form.data.name})
            .then(this.responseHandler)
      },

      /**
       * Stripe postback promise
       */
      responseHandler (response) {
        if (response.error) {
          this.formError = response.error.message
          this.proccessing = false
        } else {
          let {token} = response
          let {card} = token
          let formData = {
            paymentToken: token.id,
            storeCard: 'true',
            cardName: this.form.data.name,
            lastFour: card.last4,
            cardExpMonth: card.exp_month,
            cardExpYear: card.exp_year,
            cardBrand: card.brand,
            cardFunding: card.funding,
            button: 'Save'
          }
          Interrupt.post(formData, this.headers)
                   .then(this.success, this.failed)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// stripe.vue?61688132